/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { Dropdown, Menu, message as toaster } from 'antd';
import { useSelector } from 'react-redux';
import * as Pusher from 'pusher-js';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import { getNotifications, putNotifications } from 'store/notification';
import { Box, Image, Text, Flex } from 'atoms';
import { useAuth } from 'hooks';
import RejectionIcon from 'assets/rejection-icon.svg';

let pusher = null;

export default function RejectionNotificationPusher({ getLatestInvoices }) {
	const [notifications, setNotifications] = useState([]);
	const pusherData = useRef();
	const history = useHistory();
	const { invoiceDate } = useSelector((state) => state.app);

	const { id } = useAuth();

	function loadNotifications() {
		getNotifications({ invoiceDate, id }).then((res) => {
			setNotifications(res);
		});
	}

	const showErrorMessage = (data = {}) => {
		const { created_by_role, collection_invoice_number, remark } = data;

		console.log(data, 'Push notification');

		toaster.error(
			`${created_by_role} Rejected Your Invoice ${collection_invoice_number}, the reason is ${remark}`
		);
		getLatestInvoices();
		loadNotifications();
	};

	const mystyle = {
		margin: '0 4px',
		borderBottom: '1px solid #ededed',
	};

	useEffect(() => {
		if (id && !pusherData.current) {
			pusher = new Pusher(process.env.REACT_APP_PUSHER_CODE, {
				cluster: 'ap2',
				forceTLS: true,
			});
			const channel = pusher.subscribe(`salesmen_${id}`);

			/** *
			 * add pusher details to ref, this will create channel one time only
			 */
			pusherData.current = pusher;

			/**
			 * Channels
			 */

			/**
			 * Events
			 */
			channel.bind('invoice_reject', (data) => {
				console.log('invoice_reject', data);
				showErrorMessage(data?.message?.body);
			});
			/**
			 * Events
			 */
			channel.bind('payment_reject', (data) => {
				console.log('payment_reject', data);
				showErrorMessage(data?.message?.body);
			});
		} else {
			console.log('pusher already added', pusherData, pusher);
		}

		return () => {
			console.log('came for unsubscribe');
			if (pusher && id) {
				pusher.unsubscribe(`salesmen_${id}`);
				pusherData.current = null;
			}
		};
	}, [id]);

	useEffect(() => {
		loadNotifications();
	}, [invoiceDate]);

	function acknowledgeNotification(n) {
		putNotifications(n.id).then(() => {
			loadNotifications();
		});
	}

	const handleData = (data) => {
		const { collection_invoice_id, storeId } = data?.body || {};

		if (collection_invoice_id && storeId) {
			history.push(`/store?invoiceId=${collection_invoice_id}&storeId=${storeId}`);
			acknowledgeNotification(data);
		} else {
			toaster.error(`Invoice ID not available`);
		}
	};

	const menu = (
		<Menu
			items={notifications?.map((data, i) => ({
				label: (
					<Box
						style={i !== notifications.length - 1 ? mystyle : null}
						onClick={() => handleData(data)}
					>
						<Flex flexDirection="column" alignItems="flex-end">
							<Text
								maxWidth="300px"
								textAlign="right"
								lineHeight="16px"
								fontSize="12px"
							>
								{data?.body?.created_by_role} Rejected{' : '}
								{data?.body?.remark}
							</Text>
							<Time>{moment.utc(data?.body?.createdAt).local().fromNow()}</Time>
						</Flex>
					</Box>
				),
				key: data?.id,
			}))}
		/>
	);

	return (
		<div>
			{notifications?.length > 0 && (
				<Dropdown overlay={menu} placement="bottomRight" trigger={['click']}>
					<Box position="relative" cursor="pointer">
						<Image src={RejectionIcon} alt="Avatar" height={24} width={24} />
						<Notification>{notifications.length}</Notification>
					</Box>
				</Dropdown>
			)}
		</div>
	);
}

const Time = styled.div`
	font-size: 10px;
	border-bottom: '1px solid #ededed';
`;

const Notification = styled.div`
	position: absolute;
	top: -4px;
	right: -4px;
	width: 16px;
	height: 16px;
	background-color: white;
	font-size: 10px;
	font-weight: 400;
	line-height: 16px;
	color: black;
	border-radius: 50%;
	text-align: center;
	cursor: pointer;
`;

RejectionNotificationPusher.propTypes = {
	getLatestInvoices: PropTypes.func,
};
